const MOBILE_BREAKPOINT = 576;
const DESKTOP_MIN_CARD_WIDTH = 200;
const MOBILE_MIN_CARD_WIDTH = 150;
const DESKTOP_GRID_GAP = 15;
const MOBILE_GRID_GAP = 2;
const GRID_ROWS_PER_PAGE = 3;

export function resolveResponsiveGridItemsPerPage(containerWidth, viewportWidth = 0, options = {}) {
  const safeContainerWidth = Number(containerWidth) || 0;
  const rowsPerPage = Number(options.rowsPerPage) || GRID_ROWS_PER_PAGE;
  if (safeContainerWidth <= 0) {
    return rowsPerPage;
  }

  const safeViewportWidth = Number(viewportWidth) || 0;
  const mobileBreakpoint = Number(options.mobileBreakpoint) || MOBILE_BREAKPOINT;
  const isMobileViewport = safeViewportWidth > 0 && safeViewportWidth <= mobileBreakpoint;
  const minCardWidth = isMobileViewport
    ? Number(options.mobileMinCardWidth) || MOBILE_MIN_CARD_WIDTH
    : Number(options.desktopMinCardWidth) || DESKTOP_MIN_CARD_WIDTH;
  const gridGap = isMobileViewport
    ? Number(options.mobileGridGap) || MOBILE_GRID_GAP
    : Number(options.desktopGridGap) || DESKTOP_GRID_GAP;
  const columns = Math.max(1, Math.floor((safeContainerWidth + gridGap) / (minCardWidth + gridGap)));

  return Math.max(columns * rowsPerPage, rowsPerPage);
}